import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import Path from 'routes/Path';
import { FreecodeLoading } from 'components/FreecodePage/FreecodeLoading/FreecodeLoading';
import FreecodePage from 'components/FreecodePage/FreecodePage';
import { identifiers, editorTypes } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { useFreecodeContextLayout, useFreecodeContextData } from 'hooks/useContext';
import FreecodeSummary from 'components/FreecodePage/FreecodeTabs/FreecodeDescription/FreecodeSummary';
import FreecodePreview from 'components/FreecodePage/FreecodeTabs/Creator/FreecodePreview/FreecodePreview';
import FreecodeFlow from 'components/FreecodePage/FreecodeTabs/FreecodeDescription/FreecodeFlow';
import FreecodeEditorImplementation from 'components/FreecodePage/FreecodeTabs/FreecodeCodeEditor/FreecodeEditorImplementation';
import FreecodeLayout from 'components/FreecodePage/FreecodeLayout/FreecodeLayout';
import useCreatorInspectLoadFunction from './useCreatorInspectLoadFunction';
import useCreatorInspectRunFunction from './useCreatorInspectRunFunction';

const HEADER_LINKS = [{ link: Path.customTests, label: 'Create Page' }];

export default function FreecodeCreatorInspect() {
  const { testId } = useParams();

  const { setEditorType } = useFreecodeContextLayout();
  const { testImpl } = useFreecodeContextData();

  const { loading, error } = useCreatorInspectLoadFunction(testId);

  useCreatorInspectRunFunction();

  useEffect(() => {
    setEditorType(editorTypes.creatorInspect);
  }, [setEditorType]);

  const creatorInspectComponents = useMemo(() => {
    if (loading) return {};
    let components = {
      [identifiers.summary]: <FreecodeSummary />,
      [identifiers.implementation]: <FreecodeEditorImplementation />,
      [identifiers.preview]: <FreecodePreview />,
    };
    if (testImpl.isFlow) components[identifiers.flow] = <FreecodeFlow />;
    return components;
  }, [loading, testImpl?.isFlow]);

  return (
    <FreecodePage headerLinks={HEADER_LINKS}>
      <FreecodeLoading
        signInRequired
        loading={loading}
        errors={[error]}
        errorLinkText="Go to home page"
        errorLink={Path.landingPage}
      />
      {!loading && <FreecodeLayout parentComponents={creatorInspectComponents} />}
    </FreecodePage>
  );
}
